module.exports = __webpack_public_path__ + "img/blank.d8ac1016.jpg";